import { render, staticRenderFns } from "./OdporucteBoryPodmienky.vue?vue&type=template&id=2ff82405&scoped=true"
import script from "./OdporucteBoryPodmienky.vue?vue&type=script&lang=js"
export * from "./OdporucteBoryPodmienky.vue?vue&type=script&lang=js"
import style0 from "./OdporucteBoryPodmienky.vue?vue&type=style&index=0&id=2ff82405&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff82405",
  null
  
)

export default component.exports